import { isManifestPending } from "components/Global/Approvals/utils/approvals-helpers";
import getApprovalValue from "utils/value-types/get-value/approval";

export default function isRowPendingV3(r) {
  return isManifestPending(getApprovalValue(r.approval));
}
